import React from 'react'

const ClientProjects=React.lazy(()=>import('./ClientProjects'));
const ClientProjectForm =React.lazy(()=>import('./ClientProjectForm'));
export {
    ClientProjects,
    ClientProjectForm
}